import SwiperCentered from '../../components/swiper/image';

const carouselImage = document.querySelectorAll('.carousel-image');

carouselImage.forEach((carousel) => {
  const swiperEl = carousel.querySelector('.swiper');

  // eslint-disable-next-line no-new
  if (swiperEl) new SwiperCentered(swiperEl);
});
